import api from '@/api'

// 国家 - 列表
export function getRegionList(data) {
    return api({
        url: '/api/region/region/page.api',
        method: 'post',
        data
    })
}
// 国家 - 删除
export function delRegion(data) {
    return api({
        url: '/api/region/region/del.api',
        method: 'post',
        data
    })
}

// 国家 - 添加
export function addRegion(data) {
    return api({
        url: '/api/region/region/ins.api',
        method: 'post',
        data
    })
}

// 国家 - 编辑
export function editRegion(data) {
    return api({
        url: '/api/region/region/upd.api',
        method: 'post',
        data
    })
}

// 国家 - 开启/关闭视频模式
export function editRegionVideoStatus(data) {
    return api({
        url: '/api/region/region/video/submit.api',
        method: 'post',
        data
    })
}

// 视频分类 - 列表
export function getVideoCategoryList(data) {
    return api({
        url: '/api/category/category/page.api',
        method: 'post',
        data
    })
}
// 视频分类 - 删除
export function delVideoCategory(data) {
    return api({
        url: '/api/category/category/del.api',
        method: 'post',
        data
    })
}

// 视频分类 - 添加
export function addVideoCategory(data) {
    return api({
        url: '/api/category/category/ins.api',
        method: 'post',
        data
    })
}

// 视频分类 - 编辑
export function editVideoCategory(data) {
    return api({
        url: '/api/category/category/upd.api',
        method: 'post',
        data
    })
}

// 商品分类 - 列表
export function getProductCategoryList(data) {
    return api({
        url: '/api/category/commodity/getList.api',
        method: 'post',
        data
    })
}
// 商品分类 - 删除
export function delProductCategory(data) {
    return api({
        url: '/api/category/commodity/delete.api',
        method: 'post',
        data
    })
}

// 商品分类 - 添加
export function addProductCategory(data) {
    return api({
        url: '/api/category/commodity/insert.api',
        method: 'post',
        data
    })
}

// 商品分类 - 编辑
export function editProductCategory(data) {
    return api({
        url: '/api/category/commodity/update.api',
        method: 'post',
        data
    })
}

// 走马灯 - 列表
export function getCarouselList(data) {
    return api({
        url: '/api/ad_pic/ad_pic/page.api',
        method: 'post',
        data
    })
}

// 走马灯 - 删除
export function delCarousel(data) {
    return api({
        url: '/api/ad_pic/ad_pic/del.api',
        method: 'post',
        data
    })
}

// 走马灯 - 添加
export function addCarousel(data) {
    return api({
        url: '/api/ad_pic/ad_pic/ins.api',
        method: 'post',
        data
    })
}

// 走马灯 - 编辑
export function editCarousel(data) {
    return api({
        url: '/api/ad_pic/ad_pic/upd.api',
        method: 'post',
        data
    })
}

// VPN - 列表
export function getVpnList(data) {
    return api({
        url: '/api/vpn_conf/page.api',
        method: 'post',
        data
    })
}

// VPN - 删除
export function delVpn(data) {
    return api({
        url: '/api/vpn_conf/del.api',
        method: 'post',
        data
    })
}

// VPN - 添加
export function addVpn(data) {
    return api({
        url: '/api/vpn_conf/ins.api',
        method: 'post',
        data
    })
}

// VPN - 编辑
export function editVpn(data) {
    return api({
        url: '/api/vpn_conf/upd.api',
        method: 'post',
        data
    })
}

// 资讯类型 - 列表
export function getNewsTypeList(data) {
    return api({
        url: '/api/zx_type/page.api',
        method: 'post',
        data
    })
}

// 资讯类型 - 添加
export function addNewsType(data) {
    return api({
        url: '/api/zx_type/ins.api',
        method: 'post',
        data
    })
}

// 资讯类型 - 编辑
export function editNewsType(data) {
    return api({
        url: '/api/zx_type/upd.api',
        method: 'post',
        data
    })
}

// 资讯类型 - 下拉选项
export function getNewsTypeOptions(data) {
    return api({
        url: '/api/zx_type/list.api?lang=' + data.lang,
        method: 'post',
        data: {}
    })
}

// 资讯推送 - 列表
export function getNewsPushList(data) {
    return api({
        url: '/api/zx_content/zx_content/page.api',
        method: 'post',
        data
    })
}

// 资讯推送 - 删除
export function delNewsPush(data) {
    return api({
        url: '/api/zx_content/zx_content/del.api',
        method: 'post',
        data
    })
}

// 资讯推送 - 添加
export function addNewsPush(data) {
    return api({
        url: '/api/zx_content/zx_content/ins.api',
        method: 'post',
        data
    })
}

// 资讯推送 - 编辑
export function editNewsPush(data) {
    return api({
        url: '/api/zx_content/zx_content/upd.api',
        method: 'post',
        data
    })
}
// 资讯推送 - 获取前台入口状态
export function getNewsPushEntrance(data) {
    return api({
        url: '/api/zx_content/zx_content/gate/getStatus.api',
        method: 'post',
        data
    })
}
// 资讯推送 - 设置前台入口状态
export function setNewsPushEntrance(data) {
    return api({
        url: '/api/zx_content/zx_content/gate.api',
        method: 'post',
        data
    })
}

// 金刚区（首页） - 列表
export function getQuickLinkList(data) {
    return api({
        url: '/api/common/feature/getList',
        method: 'post',
        data
    })
}

// 金刚区（首页） - 删除
export function delQuickLink(data) {
    return api({
        url: '/api/common/feature/delFeature',
        method: 'post',
        data
    })
}

// 金刚区（首页） - 添加
export function addQuickLink(data) {
    return api({
        url: '/api/common/feature/addFeature',
        method: 'post',
        data
    })
}

// 金刚区（首页） - 编辑
export function editQuickLink(data) {
    return api({
        url: '/api/common/feature/editFeature',
        method: 'post',
        data
    })
}

// 金刚区（工作台） - 列表
export function getWorkbenchQuickLinkList(data) {
    return api({
        url: '/api/common/workbench/feature/getList.api',
        method: 'post',
        data
    })
}

// 金刚区（工作台） - 删除
export function delWorkbenchQuickLink(data) {
    return api({
        url: '/api/common/workbench/feature/delete.api',
        method: 'post',
        data
    })
}

// 金刚区（工作台） - 添加
export function addWorkbenchQuickLink(data) {
    return api({
        url: '/api/common/workbench/feature/insert.api',
        method: 'post',
        data
    })
}

// 金刚区（工作台） - 编辑
export function editWorkbenchQuickLink(data) {
    return api({
        url: '/api/common/workbench/feature/update.api',
        method: 'post',
        data
    })
}
// 文章信息 - 列表
export function getArticleInfoList(data) {
    return api({
        url: '/api/wz_pic/page.api',
        method: 'post',
        data
    })
}

// 文章信息 - 删除
export function delArticleInfo(data) {
    return api({
        url: '/api/wz_pic/del.api',
        method: 'post',
        data
    })
}

// 文章信息 - 添加
export function addArticleInfo(data) {
    return api({
        url: '/api/wz_pic/ins.api',
        method: 'post',
        data
    })
}

// 文章信息 - 编辑
export function editArticleInfo(data) {
    return api({
        url: '/api/wz_pic/upd.api',
        method: 'post',
        data
    })
}

// 文章类型 - 下拉选项
export function getArticleTypeOptions(data) {
    return api({
        url: '/api/wz_type/list.api?lang=' + data.lang,
        method: 'post',
        data: {}
    })
}

// 文章类型 - 列表
export function getArticleTypeList(data) {
    return api({
        url: '/api/wz_type/page.api',
        method: 'post',
        data
    })
}

// 文章类型 - 添加
export function addArticleType(data) {
    return api({
        url: '/api/wz_type/ins.api',
        method: 'post',
        data
    })
}

// 文章类型 - 编辑
export function editArticleType(data) {
    return api({
        url: '/api/wz_type/upd.api',
        method: 'post',
        data
    })
}

// 签到 - 列表
export function getSignInList(data) {
    return api({
        url: '/api/qian_dao/page.api',
        method: 'post',
        data
    })
}
// 签到 - 编辑
export function editSignIn(data) {
    return api({
        url: '/api/qian_dao/upd.api',
        method: 'post',
        data
    })
}

// 接口 - 列表
export function getInterfaceList(data) {
    return api({
        url: '/api/api_info/page.api',
        method: 'post',
        data
    })
}

// 接口 - 添加
export function addInterface(data) {
    return api({
        url: '/api/api_info/ins.api',
        method: 'post',
        data
    })
}

// 接口 - 编辑
export function editInterface(data) {
    return api({
        url: '/api/api_info/upd.api',
        method: 'post',
        data
    })
}

// 任务管理 - 列表
export function getTaskList(data) {
    return api({
        url: '/api/task_info/page.api',
        method: 'post',
        data
    })
}

// 任务管理 - 删除
export function delTask(data) {
    return api({
        url: '/api/task_info/del.api',
        method: 'post',
        data
    })
}

// 任务管理 - 添加
export function addTask(data) {
    return api({
        url: '/api/task_info/ins.api',
        method: 'post',
        data
    })
}

// 任务管理 - 编辑
export function editTask(data) {
    return api({
        url: '/api/task_info/upd.api',
        method: 'post',
        data
    })
}

// 商品管理 - 列表
export function getGoodList(data) {
    return api({
        url: '/api/goods/page.api',
        method: 'post',
        data
    })
}

// 商品管理 - 删除
export function delGood(data) {
    return api({
        url: '/api/goods/del.api',
        method: 'post',
        data
    })
}

// 商品管理 - 添加
export function addGood(data) {
    return api({
        url: '/api/goods/ins.api',
        method: 'post',
        data
    })
}

// 商品管理 - 编辑
export function editGood(data) {
    return api({
        url: '/api/goods/upd.api',
        method: 'post',
        data
    })
}

// 系统邀请码 - 列表
export function getInvitationCodeList(data) {
    return api({
        url: '/api/invitationcode/page.api',
        method: 'post',
        data
    })
}

// 系统邀请码 - 添加
export function addInvitationCode(data) {
    return api({
        url: '/api/invitationcode/ins.api',
        method: 'post',
        data
    })
}

// 系统邀请码 - 编辑
export function editInvitationCode(data) {
    return api({
        url: '/api/invitationcode/upd.api',
        method: 'post',
        data
    })
}

// 会员等级 - 列表
export function getLevelList(data) {
    return api({
        url: '/api/levelaccount/page.api',
        method: 'post',
        data
    })
}

// 会员等级 - 添加
export function addLevel(data) {
    return api({
        url: '/api/levelaccount/ins.api',
        method: 'post',
        data
    })
}

// 会员等级 - 编辑
export function editLevel(data) {
    return api({
        url: '/api/levelaccount/upd.api',
        method: 'post',
        data
    })
}

// 套餐信息 - 列表
export function getPackageList(data) {
    return api({
        url: '/api/taocan_info/taocan_info/page.api',
        method: 'post',
        data
    })
}

// 套餐信息 - 删除
export function delPackage(data) {
    return api({
        url: '/api/taocan_info/taocan_info/del.api',
        method: 'post',
        data
    })
}

// 套餐信息 - 添加
export function addPackage(data) {
    return api({
        url: '/api/taocan_info/taocan_info/ins.api',
        method: 'post',
        data
    })
}

// 套餐信息 - 编辑
export function editPackage(data) {
    return api({
        url: '/api/taocan_info/taocan_info/upd.api',
        method: 'post',
        data
    })
}

// 版本信息 - 列表
export function getVersionList(data) {
    return api({
        url: '/api/version_info/version_info/page.api',
        method: 'post',
        data
    })
}

// 版本信息 - 删除
export function delVersion(data) {
    return api({
        url: '/api/version_info/version_info/del.api',
        method: 'post',
        data
    })
}

// 版本信息 - 添加
export function addVersion(data) {
    return api({
        url: '/api/version_info/version_info/ins.api',
        method: 'post',
        data
    })
}

// 版本信息 - 编辑
export function editVersion(data) {
    return api({
        url: '/api/version_info/version_info/upd.api',
        method: 'post',
        data
    })
}

// 版本渠道 - 列表
export function getVersionChannelList(data) {
    return api({
        url: '/api/version_chnl_info/version_chnl_info/page.api',
        method: 'post',
        data
    })
}

// 版本渠道 - 删除
export function delVersionChannel(data) {
    return api({
        url: '/api/version_chnl_info/version_chnl_info/del.api',
        method: 'post',
        data
    })
}

// 版本渠道 - 添加
export function addVersionChannel(data) {
    return api({
        url: '/api/version_chnl_info/version_chnl_info/ins.api',
        method: 'post',
        data
    })
}

// 版本渠道 - 编辑
export function editVersionChannel(data) {
    return api({
        url: '/api/version_chnl_info/version_chnl_info/upd.api',
        method: 'post',
        data
    })
}

// 系统参数 - 列表
export function getParameterList(data) {
    return api({
        url: '/api/sys/sys_set/page.api',
        method: 'post',
        data
    })
}

// 系统参数 - 删除
export function delParameter(data) {
    return api({
        url: '/api/sys/sys_set/del.api',
        method: 'post',
        data
    })
}

// 系统参数 - 添加
export function addParameter(data) {
    return api({
        url: '/api/sys/sys_set/ins.api',
        method: 'post',
        data
    })
}

// 系统参数 - 编辑
export function editParameter(data) {
    return api({
        url: '/api/sys/sys_set/upd.api',
        method: 'post',
        data
    })
}
